export interface IEmail {
  destinationAddress: string
  body: string
  subject: string
  replyTo?: string
}

export type IEmailParagraph =
  | string
  | IEmailButton
  | IEmailPlusBox
  | IEmailLine
  | IEmailTitle
  | IEmailSubTitle
  | IEmailMainText
  | IEmailNotificationBox
  | IEmailRequestBox
  | IEmailLineThin
  | IEmailGap
  | IEmailTitledText
  | IEmailActionText
  | IEmailTwoBoxStatistics
  | IEmailSingleBoxStatistic
  | IEmailPinkText
  | IEmailTitledBox

export interface IEmailProps {
  picture?: string
  companyName: string
  subject: string
  firstLine?: string
  paragraphs: IEmailParagraph[]
  companyColors?: { [key: string]: number[] }
}

export interface ISupportEmailProps {
  supportTicketId: string
  supportSubmissionTime: string
  supportCategory: string
  supportDescription: string
  fullName: string
  accountType?: string
  email: string
}

export type ISupportEmailRequest = Pick<
  ISupportEmailProps,
  'supportCategory' | 'supportDescription'
>

export interface IEmailButton {
  text: string
  url: string
}

export interface IEmailPlusBox {
  plus: number
  text: string
}

export interface IEmailTitledText {
  title: string
  text: string
}

export interface IEmailPinkText {
  pinkText: string
}

export interface IEmailTitledBox {
  titledBox: string
}

export interface IEmailActionText {
  actionText: string
}

export interface IEmailTwoBoxStatistics {
  leftBoxNumber: string
  leftBoxText: string
  rightBoxNumber: string
  rightBoxText: string
}
export interface IEmailSingleBoxStatistic {
  boxNumber: string
  boxText: string
}

export interface IEmailTitle {
  title: string
}

export interface IEmailSubTitle {
  subTitle: string
}

export interface IEmailMainText {
  mainText: string
}

export interface IEmailNotificationBox {
  notificationTitle: string
  text: string
  url?: string
}

export interface IEmailRequestBox {
  requestTitle: string
  text: string
  url?: string
}

export type IEmailLine = 'line'

export type IEmailLineThin = 'lineThin'

export type IEmailGap = 'gap'

export function isEmailButton(item: IEmailParagraph): item is IEmailButton {
  return item instanceof Object && 'text' in item && 'url' in item
}

export function isEmailLine(item: IEmailParagraph): item is IEmailLine {
  return item === 'line'
}

export function isEmailLineThin(item: IEmailParagraph): item is IEmailLine {
  return item === 'lineThin'
}

export function isEmailGap(item: IEmailParagraph): item is IEmailLine {
  return item === 'gap'
}
export function isEmailTitle(item: IEmailParagraph): item is IEmailTitle {
  return item instanceof Object && 'title' in item
}

export function isEmailSubTitle(item: IEmailParagraph): item is IEmailSubTitle {
  return item instanceof Object && 'subTitle' in item
}

export function isEmailMainText(item: IEmailParagraph): item is IEmailMainText {
  return item instanceof Object && 'mainText' in item
}

export function isEmailNotificationBox(
  item: IEmailParagraph
): item is IEmailNotificationBox {
  return item instanceof Object && 'notificationTitle' in item && 'text' in item
}
export function isEmailRequestBox(
  item: IEmailParagraph
): item is IEmailRequestBox {
  return item instanceof Object && 'requestTitle' in item && 'text' in item
}
export function isEmailPlusBox(item: IEmailParagraph): item is IEmailPlusBox {
  return item instanceof Object && 'text' in item && 'plus' in item
}

export function isEmailTitledText(
  item: IEmailParagraph
): item is IEmailTitledText {
  return item instanceof Object && 'text' in item && 'title' in item
}

export function isEmailTitledBox(
  item: IEmailParagraph
): item is IEmailTitledBox {
  return item instanceof Object && 'titledBox' in item
}

export function isEmailActionText(
  item: IEmailParagraph
): item is IEmailActionText {
  return item instanceof Object && 'actionText' in item
}

export function isEmailSingleBoxStatistic(
  item: IEmailParagraph
): item is IEmailSingleBoxStatistic {
  return item instanceof Object && 'boxNumber' in item && 'boxText' in item
}

export function isEmailPinkText(item: IEmailParagraph): item is IEmailPinkText {
  return item instanceof Object && 'pinkText' in item
}

export function isEmailTwoBoxStatistics(
  item: IEmailParagraph
): item is IEmailTwoBoxStatistics {
  return (
    item instanceof Object &&
    'leftBoxNumber' in item &&
    'leftBoxText' in item &&
    'rightBoxNumber' in item &&
    'rightBoxText' in item
  )
}

export const SupportEmailCategories = [
  { key: '', value: 'general.forms.chooseOption' },
  { key: 'question', value: 'email.labelQuestion' },
  { key: 'technical', value: 'email.labelTechnical' },
  { key: 'feature', value: 'email.labelFeature' },
  { key: 'hello', value: 'email.labelHello' },
  { key: 'else', value: 'email.labelElse' },
]
